module.exports = __webpack_public_path__ + "static/media/gameplay3-en.1971e1f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/gameplay3-en.png
// module id = 190
// module chunks = 0